export const MultiLineText = (props: { text: string } & React.HTMLAttributes<HTMLDivElement>) => {
  const { text, ...divProps } = props;

  return (
    <div {...divProps}>
      {text.split("\n").map((x, idx) => (
        <span key={`mlt_${idx}`}>
          {x}
          <br />
        </span>
      ))}
    </div>
  );
};
